import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface ExpandableCellProps extends ComponentProps<'span'> {
  name: string
  maxLength: number
  isExpanded: boolean
}

export function ExpandableCell({
  name,
  maxLength,
  isExpanded,
  className,
}: ExpandableCellProps) {
  function IsCompleteTextVisible() {
    const isLong = name?.length > maxLength

    return isExpanded || !isLong
  }

  return (
    <span className={twMerge('', className)}>
      {IsCompleteTextVisible() ? name : name?.slice(0, maxLength) + '...'}
    </span>
  )
}
